import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth'
import user from '@/store/modules/user'
import client from '@/store/modules/client'
import reception from '@/store/modules/reception'
import schedule from '@/store/modules/schedule'
import notes from '@/store/modules/notes'
import relatives from '@/store/modules/relatives'
import account from '@/store/modules/account'
import visits from '@/store/modules/visits'
import lesson from '@/store/modules/lesson'
import clientCalls from '@/store/modules/clientCalls'
import sale from '@/store/modules/sale'
import cashbox from '@/store/modules/cashbox'
import refund from '@/store/modules/return'
import bill from '@/store/modules/bill'
import monitor from '@/store/modules/monitor'
import advertising from '@/store/modules/advertising'
import tasks from '@/store/modules/tasks'
import renewal from '@/store/modules/renewal'
import deals from '@/store/modules/deals'
import organization from '@/store/modules/organization'
import department from '@/store/modules/department'
import room from '@/store/modules/room'
import config from '@/store/modules/config'
import uis from '@/store/modules/uis'
import report from '@/store/modules/report'
import tags from '@/store/modules/tags'
import nomenclature from '@/store/modules/nomenclature'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { userInterface: null, userType: null, userFIO: null, preloader: false, error: null, },
  mutations: {
    setUserInterface: (state, data) => state.userInterface = data,
    unSetUserInterface: (state) => state.userInterface = null,
    setUserType: (state, data) => state.userType = data,
    setUserFIO: (state, data) => state.userFIO = data,
    showPreloader: (state, data) => state.preloader = data,
    setError: (state, data) => state.error = data,
    clearError: (state) => state.error = null,
  },
  actions: {},
  modules: {
    auth,
    user,
    client,
    reception,
    schedule,
    notes,
    relatives,
    account,
    visits,
    lesson,
    clientCalls,
    sale,
    cashbox,
    refund,
    bill,
    monitor,
    advertising,
    tasks,
    renewal,
    deals,
    organization,
    department,
    room,
    config,
    uis,
    report,
    tags,
    nomenclature
  }
})
